var map = {
	"./boat.svg": "1d38",
	"./bus.svg": "49cc",
	"./car.svg": "2cc5",
	"./face_sad.svg": "0ce8",
	"./helicopter.svg": "3f84",
	"./icon_bags.svg": "d9a1",
	"./icon_business.svg": "8768",
	"./icon_check.svg": "04ab",
	"./icon_clock.svg": "f171",
	"./icon_economy.svg": "f8a8",
	"./icon_info.svg": "3e8f",
	"./icon_passengers.svg": "e832",
	"./icon_premium.svg": "a9d4",
	"./icon_standard.svg": "7d59",
	"./limousine.svg": "1a79",
	"./loader.svg": "4091",
	"./moto.svg": "be0f",
	"./mozio.svg": "652f",
	"./shuttle.svg": "12e8",
	"./suv.svg": "88c2",
	"./taxi.svg": "6120"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "70d9";